import { FC } from "react";
import PageErrorTemplate from "./PageErrorTemplate";

const PageError404: FC = () => {
  return (
    <PageErrorTemplate errorCode={404} errorMessage="Page Not Found" />
  );
};

export default PageError404;